module.exports = __webpack_public_path__ + "img/take-away.3b773d36.png";